<template>
  <button @click="$emit('click')" v-ripple class="fat-button" :style='{ width, maxWidth, padding }'>
    <slot></slot>
  </button>
</template>

<script>
export default {
  emits: ['click'],
  props: {
    maxWidth: String,
    width: String,
    padding: String,
  }
}
</script>

<style scoped lang="scss">
.fat-button {
  background: var(--color-blue);
  color: var(--color-black);
  cursor: pointer;
  padding: 12px;
  border: var(--border-width) solid var(--color-black);
  position: relative;
  text-transform: uppercase;
  user-select: none;
  font-weight: 800;
  font-size: var(--fs-1);
  letter-spacing: 1px;
}
</style>
